import styled from "styled-components";
import {
  BREAKPOINTS,
  COLORS,
  TYPOGRAPHY
} from "../../containers/impact-report/constants";

export const CarouselSection = styled.section`
  background-color: ${COLORS.WHITE};
  padding: 60px 0 60px 24px;
  width: 100%;
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 100px 24px;
    max-width: 1366px;
    margin: 0 auto;
  }
`;

export const SectionTitle = styled.h2`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 32px 0;
  text-align: left;
  padding-right: 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.HEADING_XLARGE_MEDIUM}
    margin: 0 0 40px 0;
    text-align: center;
    padding-right: 0;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  touch-action: pan-y;
  width: calc(100% - 24px);

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: none;
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  gap: 12px;
  transition: transform ${props => props.transitionDuration}ms
    ${props => props.transitionEasing};
  transform: translateX(-${props => props.currentSlide * 100}%);
  width: 100%;
`;

export const DesktopGrid = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: flex;
    justify-content: center;
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;
  }

  @media (min-width: ${BREAKPOINTS.LG}) {
    gap: 85px;
  }
`;

export const Card = styled.div`
  width: calc(100% - 12px);
  flex-shrink: 0;
  box-sizing: border-box;
  border: 1px solid ${COLORS.BORDER_COLOR};
  background-color: ${COLORS.WHITE};
  border-radius: 12px;
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.MD}) {
    min-width: 0;
    width: 100%;
    max-width: 325px;
    flex: 1;
    border: none;
  }
`;

export const ImageSection = styled.div`
  height: 325px;
  background-color: ${COLORS.CONTENT_MUTED};
  border-bottom: 1px solid ${COLORS.BORDER_COLOR};
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.MD}) {
    background-color: transparent;
    border-bottom: none;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  object-fit: cover;

  @media (min-width: ${BREAKPOINTS.MD}) {
    object-fit: contain;
  }
`;

export const TextSection = styled.div`
  padding: 40px 30px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 40px 0 0;
    text-align: center;
  }
`;

export const CardTitle = styled.h3`
  ${TYPOGRAPHY.H1_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 10px 0;
`;

export const CardDescription = styled.p`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
  }
`;

export const PaginationDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: none;
  }
`;

export const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid
    ${props =>
      props.active ? COLORS.PRIMARY_BASE : COLORS.TERTIARY_BORDER_DEEP};
  padding: 0;
  cursor: pointer;
  background-color: ${props =>
    props.active ? COLORS.WHITE : COLORS.TERTIARY_BORDER_DEEP};

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: 2px solid ${COLORS.PRIMARY_BASE};
    outline-offset: 2px;
  }
`;
